module.exports = __webpack_public_path__ + "img/diapositiva-4-2.986fe5df.png";